import { ReactElement, ReactNode, SyntheticEvent } from 'react';
import { SxProps, Theme } from '@mui/material';

import { StyledTab, StyledTabs } from './MplTabs.styles';

export interface IMplTab {
	label: ReactNode;
	value: string | number;
	disabled?: boolean;
	icon?: ReactElement;
	sx?: SxProps<Theme>;
	testId?: string;
}

export interface IMplTabsProps {
	tabs: IMplTab[];
	value: string | number;
	onChange: (value: string | number) => void;
	scrollable?: boolean;
	indicatorColor?: string;
	/**
	 * Height in px of both the active indicator and the inactive bottom rule.
	 * Defaults to 1.
	 */
	dividerHeight?: number;
	disableRipple?: boolean;
	dataTestId?: string;
}

export const MplTabs = ({
	tabs,
	value,
	onChange,
	dataTestId,
	scrollable = true,
	indicatorColor,
	dividerHeight,
	disableRipple,
}: IMplTabsProps) => {
	const handleChange = (
		_event: SyntheticEvent<Element, Event>,
		newValue: string | number
	) => {
		onChange(newValue);
	};

	return (
		<StyledTabs
			value={value}
			onChange={handleChange}
			variant={scrollable ? 'scrollable' : 'fullWidth'}
			scrollButtons={false}
			data-testid={dataTestId}
			indicatorBgColor={indicatorColor}
			dividerHeight={dividerHeight}
		>
			{tabs.map((tab) => (
				<StyledTab
					key={tab.value}
					value={tab.value}
					label={tab.label}
					icon={tab.icon}
					iconPosition={tab.icon ? 'start' : undefined}
					disabled={tab.disabled}
					sx={tab.sx ?? { padding: '4px 16px 14px 16px' }}
					disableRipple={disableRipple}
					data-testid={tab.testId}
				/>
			))}
		</StyledTabs>
	);
};
